import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Heart } from 'lucide-react';
import { products } from '../mock/mock';
import { useCart } from '../context/CartContext';

const Wishlist = () => {
  const { wishlist, toggleWishlist } = useCart();

  useEffect(() => { window.scrollTo(0, 0); }, []);

  const items = products.filter((p) => wishlist.includes(p.id));

  return (
    <div className="pt-32 pb-32">
      <div className="max-w-[1600px] mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <p className="text-[11px] tracking-[0.22em] uppercase text-neutral-500 mb-5">Saved For Later</p>
          <h1 className="font-display text-5xl md:text-6xl font-medium tracking-tight">Wishlist</h1>
        </div>

        {items.length === 0 ? (
          <div className="py-20 text-center max-w-md mx-auto">
            <Heart className="w-10 h-10 mx-auto mb-6 text-neutral-300" strokeWidth={1} />
            <p className="font-display text-2xl mb-3">Your wishlist is empty</p>
            <p className="text-sm text-neutral-500 mb-8">
              Save the pieces you love to revisit them later.
            </p>
            <Link
              to="/shop"
              className="inline-block bg-neutral-900 text-white px-10 py-4 text-[11px] tracking-[0.22em] uppercase hover:bg-neutral-700 transition-colors"
            >
              Discover Pieces
            </Link>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 lg:gap-10">
            {items.map((p) => (
              <div key={p.id} className="group">
                <Link to={`/product/${p.id}`} className="block">
                  <div className="relative aspect-[3/4] overflow-hidden bg-neutral-100 mb-5">
                    <img
                      src={p.image}
                      alt={p.name}
                      className="w-full h-full object-cover group-hover:scale-[1.035] transition-transform duration-[3500ms] ease-[cubic-bezier(0.22,1,0.36,1)]"
                    />
                    <button
                      onClick={(e) => { e.preventDefault(); toggleWishlist(p.id); }}
                      className="absolute top-4 right-4 w-9 h-9 bg-white/90 backdrop-blur-sm flex items-center justify-center hover:bg-white transition-colors rounded-full"
                      aria-label="Remove from wishlist"
                    >
                      <Heart className="w-4 h-4" strokeWidth={1.5} fill="currentColor" />
                    </button>
                  </div>
                  <h3 className="text-sm font-medium">{p.name}</h3>
                  <p className="text-sm text-neutral-700 mt-1">${p.price}</p>
                </Link>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Wishlist;
